<template>
  <div class="paragraph">
    <div class="paragraph__main">
      <div class="paragraph__list">
        <div class="paragraph__list-item">
          <div class="paragraph-item">
            <div class="paragraph-item__content">
              <h2 class="paragraph-item__title">{{ $t('useofdata.title') }}</h2>
              <div class="paragraph-item__text">
                <i18n path="useofdata.paragraphCollect" tag="p"></i18n>
                    <i18n path="useofdata.paragraphStats" tag="p"></i18n>
                    <i18n path="useofdata.paragraphSharing" tag="p"></i18n>
                    <i18n path="useofdata.paragraphPrivacy" tag="p">
                      <template v-slot:link>
                        <a target="_blank" :href="$t('useofdata.linkPrivacyUrl')">{{ $t('useofdata.linkPrivacyUrl') }}</a>
                      </template>
                    </i18n>
              </div>
            </div>
            <div class="paragraph-item__image">
              <div class="paragraph-item__picture">
                <img src="@/assets/images/picture-home-3.jpg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Blocktextimage',
};
</script>
